import { Pipe, PipeTransform } from '@angular/core';
import { PdpSortingOption } from '../../../constants/pdp-sorting.constants';
import { IOffer } from '../../../core/interfaces/offer';
import { IPropertyUnitGroup } from '../../../core/interfaces/property';

@Pipe({
  name: 'pdpAvailabilityOrder',
  standalone: false
})
export class PdpAvailabilityOrderPipe implements PipeTransform {
  transform(
    items: IPropertyUnitGroup[],
    selectedOffers: (IOffer | null)[],
    guests: number,
    externalUnitGroupIdUrl: string,
    preferedSorting: PdpSortingOption
  ): IPropertyUnitGroup[] {
    if (preferedSorting?.comparator) {
      return items.sort(preferedSorting?.comparator(selectedOffers));
    }

    return items
      .sort((a, b) => a.maxGuests - b.maxGuests)
      .sort((a, b) =>
        a.name.toLowerCase().indexOf('long') >= 0 ? 1 : b.name.toLowerCase().indexOf('long') >= 0 ? -1 : 0
      )
      .sort((a, b) => (guests > a.maxGuests ? 1 : guests > b.maxGuests ? -1 : 0))
      .sort((a, b) =>
        !selectedOffers.find((itm) => itm.unitGroupId === a.id)
          ? 1
          : !selectedOffers.find((itm) => itm.unitGroupId === b.id)
            ? -1
            : 0
      )
      .sort((a, b) => (b.externalId === externalUnitGroupIdUrl ? 1 : a.externalId === externalUnitGroupIdUrl ? -1 : 0));
  }
}
